import { createGlobalStyle } from "styled-components";

export const supportDeviceSize = 1080;

export const GlobalStyle = createGlobalStyle`
:root {
    --color-main: #522CD4;
    --color-main-light: #5F3ADB;
    --color-main-second: #F3EFFF;
    --color-gauge: #CFD1FF;
    --color-gauge-transition: #9F8FEF;
    --color-black: #000000;
    --color-black-1: #1C1C1C;
    --color-white: #FFFFFF;
    --color-grey: #F9F9F9;
    --color-sub-warning: #DD5586;
    --color-sub-delay: #F7C92A;
    --color-sub-positive: #522CD4;
    --color-grey-990: #191919;
    --color-grey-900: #15191D;
    --color-grey-800: #2A323B;
    --color-grey-700: #3A4552;
    --color-grey-600: #666F7B;
    --color-grey-500: #8E9398;
    --color-grey-400: #AEB3B8;
    --color-grey-300: #D2D7DC;
    --color-grey-200: #E3E7ED;
    --color-grey-100: #EDF1F7;
    --color-grey-50: #F4F8FC;
    --color-grey-10: #FDFDFD;
    --color-lime-700: #BEDB0A;
    --color-lime-500: #DBF15F;
    --color-lime-400: #ECFA9B;
    --color-lime-100: #F9FFD7;
    --color-purple-800: #3C16C0;
    --color-purple-700: #522CD4;
    --color-purple-600: #6A46E7;
    --color-purple-500: #8A6BF5;
    --color-purple-400: #A88FFF;
    --color-purple-300: #BBA3FF;
    --color-purple-200: #CFD1FF;
    --color-purple-100: #F3EFFF;
    --color-toast: #FFFAEA;
    --color-error: #F93B3D;
    --color-blue: #1D68FF;
    --color-skyblue: #B7CEFF;
    --color-pink: #FDCAD7;

    /* --- Safe Area Bottom (SAB) -----------------------------------
     * 2026-04-19 Hotfix v1 — Android 15(targetSdk 35) edge-to-edge 회귀
     * 원인: WebView 가 네비바 뒤까지 확장 + env(safe-area-inset-bottom) 이
     * 네비바 높이(≈48dp) 만큼 리턴 → 기존 iOS Home Indicator 용 env() 규칙이
     * Android 에서도 적용되어 하단 요소 "붕 뜨는" 회귀.
     * 대응: html.aos-no-edge-inset { --sab: 0px } 로 원복.
     *
     * 2026-04-19 Hotfix v2 — iOS 동일 증상 재발 (대표 확인).
     * 원인 추정: WKWebView 의 contentInset / additionalSafeAreaInsets 가
     * 이미 Home Indicator 높이만큼 적용된 상태에서, CSS env(safe-area-inset-bottom)
     * 까지 더해져 "이중 계산" → Footer 가 Home Indicator 의 2배 높이로 뜸.
     * 특히 iPad Mini/iPad 류에서 더 심하게 체감 (대표 확인 스크린샷).
     * 대응: Android 와 동일한 패턴 — html.ios-no-edge-inset { --sab: 0px }
     * (DefaultLayout 에서 getUserAgent() === "apple" 일 때 부착).
     *
     * 최종 정식 수정(B안) — 네이티브(iOS WKWebView / Android WebView) 에서
     * contentInset 이중 계산을 제거. docs/android-edge-to-edge-native-fix.md
     * --------------------------------------------------------------- */
    --sab: env(safe-area-inset-bottom, 0px);
}

html.aos-no-edge-inset,
html.ios-no-edge-inset {
    --sab: 0px;
}

html {
font-size: 10px; // 1rem = 10px 로 변경 한 것
// 참고링크 = https://stackoverflow.com/questions/68790660/setting-root-font-size-not-affecting-rem-units-in-safari-for-margin-padding-et
// 128px => 12.8rem , 4px => 0.4rem 가능!
-webkit-text-size-adjust: none;
-moz-text-size-adjust: none;
-ms-text-size-adjust: none;
}

html,
body {
    position: fixed;
    overflow: hidden;
}

body {
    width: 100dvw;
    margin: 0 auto;
    min-height: 100dvh;
    background: white;
    line-height: 1.4;
    letter-spacing: 0.006em;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--color-grey-900);

    #root {
        overflow-y: visible;
        -webkit-overflow-scrolling: touch;
    }

    main {
        overflow: scroll;
        height: calc(100dvh - 4.6rem);
        -ms-overflow-style: none;
        scrollbar-width: none;

        &::-webkit-scrollbar {
            display: none;
        }
        
    }

    * {
        font-family: "Pretendard Variable", Pretendard, -apple-system, BlinkMacSystemFont, system-ui, Roboto, "Helvetica Neue", "Segoe UI", "Apple SD Gothic Neo", "Noto Sans KR", "Malgun Gothic", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", sans-serif;
        border: none;
        outline: none;
        padding: 0;
        margin: 0;
        background: transparent;
        box-sizing: border-box;
        -webkit-tap-highlight-color: transparent;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
        -webkit-focus-ring-color: transparent;
    }

    h1 {
        font-size: 2.8rem;
        letter-spacing: 0;
    }

    h2 {
        font-size: 2.4rem;
        letter-spacing: 0;
    }

    h3 {
        font-size: 2rem;
        font-weight: 600;
        letter-spacing: 0;
    }

    button {
        cursor: pointer;
    }

    img {
        -webkit-user-select: none;
        user-select: none;
        -webkit-touch-callout: none;
        -webkit-user-drag: none;
        touch-action: manipulation;
    }
}
`;
